import { ReactElement } from "react";

export default function NotFound(): ReactElement {
  return (
    <main className="flex flex-1 px-6 py-6 pb-12">
      <div className="flex flex-col items-center w-full h-full text-center">
        <h1 className="mb-6 mt-2 md:mt-12">
          <img className="block max-h-20 w-auto" src="/logo.png" alt="YO! MIDI" />
        </h1>
        <p className="text-2xl mb-6 md:mb-12">
          Not Found
        </p>
        <p className="text-xl mt-4">
          Was a MIDI device disconnected?
        </p>
      </div>
    </main>
  );
}
